import React from 'react';
import PropTypes from 'prop-types';
import {
    Card,
    CardActionArea,
    CardContent,
} from '@mui/material';
import { trakrefFontFamilySemiBold } from '../utils';
import { Grey1 } from '../color_utils';
import { PageTitleWithToolTip } from './Common';

const AnalyticsMenuButton = ({
    icon,
    title,
    onClick,
    toolTipText
}) => (
    <Card
        sx={{
            flexBasis: "31%",
            width: '369px',
            height: icon ? '232px' : '100px',
            borderRadius: '8px',
            borderWidth: '0px',
            boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.05)",
            "&:hover": {
                border: "1px solid rgba(0, 0, 0, 0.08)"
            }
        }}
    >
        <CardActionArea
            onClick={onClick}
            sx={{
                ":focus": {
                    outline: "none",
                },
                height: '100%'
            }}
        >
            <CardContent>
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    flexDirection: "column",
                    gap: "0px"
                }}>
                    {icon && (
                        <img
                            style={{ paddingBottom: '4%', marginTop: '4%' }}
                            src={icon}
                            height="127px"
                            draggable="false"
                        />
                    )}
                    <span
                        style={{
                            fontFamily: trakrefFontFamilySemiBold,
                            color: Grey1,
                            fontSize: '1.063rem',
                            textAlign: 'center',
                            padding: "0px",
                        }}
                    >
                        <PageTitleWithToolTip
                            pageTitle={title}
                            toolTipText={toolTipText}
                            fontSize={'1.125rem'}
                            placement={'bottom'}
                            sx={{
                                marginLeft: "8px",
                            }}
                        />
                    </span>
                </div>
            </CardContent>
        </CardActionArea>
    </Card>
);

AnalyticsMenuButton.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    toolTipText: PropTypes.string.isRequired
};

export default AnalyticsMenuButton;
